var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChatDialog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7268_10765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95298 16.5855C6.21248 16.5855 6.39412 16.4605 6.69903 16.1711L8.58686 14.3882C8.22356 14.0921 7.92514 13.625 7.92514 12.5526V8.19079C7.92514 6.17105 9.1318 4.97368 11.1234 4.97368H15.6646L15.6581 4.72368C15.5608 3.375 14.685 2.5 13.1994 2.5H4.2987C2.81309 2.5 1.8335 3.40132 1.8335 4.96711V11.4276C1.8335 12.9934 2.81309 14 4.2987 14H5.3756V15.9145C5.3756 16.3224 5.58969 16.5855 5.95298 16.5855ZM16.4366 17.5C16.8064 17.5 17.014 17.2303 17.014 16.8289V14.9079H17.7016C19.1872 14.9079 20.1668 13.9013 20.1668 12.3421V8.34211C20.1668 6.76974 19.1872 5.875 17.7016 5.875H11.2726C9.72215 5.875 8.81392 6.76974 8.81392 8.34211V12.3421C8.81392 13.9013 9.72215 14.9079 11.2726 14.9079H13.3486L15.6905 17.0789C15.9954 17.3684 16.1771 17.5 16.4366 17.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7268_10765",
    x: 0.833496,
    y: 2.5,
    width: 20.3335,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7268_10765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7268_10765",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatDialog);
export default __webpack_public_path__ + "static/media/icon-chat-dialog.d003ee018f5f4a9e5d9406e20181be3b.svg";
export { ForwardRef as ReactComponent };